import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useEffect } from 'react';

export default function ResponsiveDialog({openModal, setModalApprove, messageDialog}) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if(openModal){
     setOpen(true)
    }
   }, [openModal])
   
 
   const handleClose = () => {
     setOpen(false);
     setModalApprove(false)
   };
 

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Attenzione!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {messageDialog.Message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Scarta
          </Button>
          <Button onClick={handleClose} autoFocus>
            Aggiungi
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}